import _classCallCheck from "/builds/www/u-design/u-design/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/www/u-design/u-design/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/builds/www/u-design/u-design/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/builds/www/u-design/u-design/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/builds/www/u-design/u-design/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/builds/www/u-design/u-design/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import XHTMLEntities from "../parser/plugins/jsx/xhtml";
import { TokenType as tt } from "../parser/tokenizer/types";
import { charCodes } from "../parser/util/charcodes";
import getJSXPragmaInfo from "../util/getJSXPragmaInfo";
import Transformer from "./Transformer";

var JSXTransformer = /*#__PURE__*/function (_Transformer) {
  _inherits(JSXTransformer, _Transformer);

  var _super = _createSuper(JSXTransformer);

  function JSXTransformer(rootTransformer, tokens, importProcessor, nameManager, options) {
    var _this;

    _classCallCheck(this, JSXTransformer);

    _this = _super.call(this);
    _this.rootTransformer = rootTransformer;
    _this.tokens = tokens;
    _this.importProcessor = importProcessor;
    _this.nameManager = nameManager;
    _this.options = options;

    JSXTransformer.prototype.__init.call(_assertThisInitialized(_this));

    JSXTransformer.prototype.__init2.call(_assertThisInitialized(_this));

    JSXTransformer.prototype.__init3.call(_assertThisInitialized(_this));

    ;
    _this.jsxPragmaInfo = getJSXPragmaInfo(options);
    return _this;
  }

  _createClass(JSXTransformer, [{
    key: "__init",
    value: function __init() {
      this.lastLineNumber = 1;
    }
  }, {
    key: "__init2",
    value: function __init2() {
      this.lastIndex = 0;
    }
  }, {
    key: "__init3",
    value: function __init3() {
      this.filenameVarName = null;
    }
  }, {
    key: "process",
    value: function process() {
      if (this.tokens.matches1(tt.jsxTagStart)) {
        this.processJSXTag();
        return true;
      }

      return false;
    }
  }, {
    key: "getPrefixCode",
    value: function getPrefixCode() {
      if (this.filenameVarName) {
        return "const ".concat(this.filenameVarName, " = ").concat(JSON.stringify(this.options.filePath || ""), ";");
      } else {
        return "";
      }
    }
    /**
     * Lazily calculate line numbers to avoid unneeded work. We assume this is always called in
     * increasing order by index.
     */

  }, {
    key: "getLineNumberForIndex",
    value: function getLineNumberForIndex(index) {
      var code = this.tokens.code;

      while (this.lastIndex < index && this.lastIndex < code.length) {
        if (code[this.lastIndex] === "\n") {
          this.lastLineNumber++;
        }

        this.lastIndex++;
      }

      return this.lastLineNumber;
    }
  }, {
    key: "getFilenameVarName",
    value: function getFilenameVarName() {
      if (!this.filenameVarName) {
        this.filenameVarName = this.nameManager.claimFreeName("_jsxFileName");
      }

      return this.filenameVarName;
    }
  }, {
    key: "processProps",
    value: function processProps(firstTokenStart) {
      var lineNumber = this.getLineNumberForIndex(firstTokenStart);
      var devProps = this.options.production ? "" : "__self: this, __source: {fileName: ".concat(this.getFilenameVarName(), ", lineNumber: ").concat(lineNumber, "}");

      if (!this.tokens.matches1(tt.jsxName) && !this.tokens.matches1(tt.braceL)) {
        if (devProps) {
          this.tokens.appendCode(", {".concat(devProps, "}"));
        } else {
          this.tokens.appendCode(", null");
        }

        return;
      }

      this.tokens.appendCode(", {");

      while (true) {
        if (this.tokens.matches2(tt.jsxName, tt.eq)) {
          this.processPropKeyName();
          this.tokens.replaceToken(": ");

          if (this.tokens.matches1(tt.braceL)) {
            this.tokens.replaceToken("");
            this.rootTransformer.processBalancedCode();
            this.tokens.replaceToken("");
          } else if (this.tokens.matches1(tt.jsxTagStart)) {
            this.processJSXTag();
          } else {
            this.processStringPropValue();
          }
        } else if (this.tokens.matches1(tt.jsxName)) {
          this.processPropKeyName();
          this.tokens.appendCode(": true");
        } else if (this.tokens.matches1(tt.braceL)) {
          this.tokens.replaceToken("");
          this.rootTransformer.processBalancedCode();
          this.tokens.replaceToken("");
        } else {
          break;
        }

        this.tokens.appendCode(",");
      }

      if (devProps) {
        this.tokens.appendCode(" ".concat(devProps, "}"));
      } else {
        this.tokens.appendCode("}");
      }
    }
  }, {
    key: "processPropKeyName",
    value: function processPropKeyName() {
      var keyName = this.tokens.identifierName();

      if (keyName.includes("-")) {
        this.tokens.replaceToken("'".concat(keyName, "'"));
      } else {
        this.tokens.copyToken();
      }
    }
  }, {
    key: "processStringPropValue",
    value: function processStringPropValue() {
      var token = this.tokens.currentToken();
      var valueCode = this.tokens.code.slice(token.start + 1, token.end - 1);
      var replacementCode = formatJSXTextReplacement(valueCode);
      var literalCode = formatJSXStringValueLiteral(valueCode);
      this.tokens.replaceToken(literalCode + replacementCode);
    }
    /**
     * Process the first part of a tag, before any props.
     */

  }, {
    key: "processTagIntro",
    value: function processTagIntro() {
      // Walk forward until we see one of these patterns:
      // jsxName to start the first prop, preceded by another jsxName to end the tag name.
      // jsxName to start the first prop, preceded by greaterThan to end the type argument.
      // [open brace] to start the first prop.
      // [jsxTagEnd] to end the open-tag.
      // [slash, jsxTagEnd] to end the self-closing tag.
      var introEnd = this.tokens.currentIndex() + 1;

      while (this.tokens.tokens[introEnd].isType || !this.tokens.matches2AtIndex(introEnd - 1, tt.jsxName, tt.jsxName) && !this.tokens.matches2AtIndex(introEnd - 1, tt.greaterThan, tt.jsxName) && !this.tokens.matches1AtIndex(introEnd, tt.braceL) && !this.tokens.matches1AtIndex(introEnd, tt.jsxTagEnd) && !this.tokens.matches2AtIndex(introEnd, tt.slash, tt.jsxTagEnd)) {
        introEnd++;
      }

      if (introEnd === this.tokens.currentIndex() + 1) {
        var tagName = this.tokens.identifierName();

        if (startsWithLowerCase(tagName)) {
          this.tokens.replaceToken("'".concat(tagName, "'"));
        }
      }

      while (this.tokens.currentIndex() < introEnd) {
        this.rootTransformer.processToken();
      }
    }
  }, {
    key: "processChildren",
    value: function processChildren() {
      while (true) {
        if (this.tokens.matches2(tt.jsxTagStart, tt.slash)) {
          // Closing tag, so no more children.
          return;
        }

        if (this.tokens.matches1(tt.braceL)) {
          if (this.tokens.matches2(tt.braceL, tt.braceR)) {
            // Empty interpolations and comment-only interpolations are allowed
            // and don't create an extra child arg.
            this.tokens.replaceToken("");
            this.tokens.replaceToken("");
          } else {
            // Interpolated expression.
            this.tokens.replaceToken(", ");
            this.rootTransformer.processBalancedCode();
            this.tokens.replaceToken("");
          }
        } else if (this.tokens.matches1(tt.jsxTagStart)) {
          // Child JSX element
          this.tokens.appendCode(", ");
          this.processJSXTag();
        } else if (this.tokens.matches1(tt.jsxText)) {
          this.processChildTextElement();
        } else {
          throw new Error("Unexpected token when processing JSX children.");
        }
      }
    }
  }, {
    key: "processChildTextElement",
    value: function processChildTextElement() {
      var token = this.tokens.currentToken();
      var valueCode = this.tokens.code.slice(token.start, token.end);
      var replacementCode = formatJSXTextReplacement(valueCode);
      var literalCode = formatJSXTextLiteral(valueCode);

      if (literalCode === '""') {
        this.tokens.replaceToken(replacementCode);
      } else {
        this.tokens.replaceToken(", ".concat(literalCode).concat(replacementCode));
      }
    }
  }, {
    key: "processJSXTag",
    value: function processJSXTag() {
      var jsxPragmaInfo = this.jsxPragmaInfo;
      var resolvedPragmaBaseName = this.importProcessor ? this.importProcessor.getIdentifierReplacement(jsxPragmaInfo.base) || jsxPragmaInfo.base : jsxPragmaInfo.base;
      var firstTokenStart = this.tokens.currentToken().start; // First tag is always jsxTagStart.

      this.tokens.replaceToken("".concat(resolvedPragmaBaseName).concat(jsxPragmaInfo.suffix, "("));

      if (this.tokens.matches1(tt.jsxTagEnd)) {
        // Fragment syntax.
        var resolvedFragmentPragmaBaseName = this.importProcessor ? this.importProcessor.getIdentifierReplacement(jsxPragmaInfo.fragmentBase) || jsxPragmaInfo.fragmentBase : jsxPragmaInfo.fragmentBase;
        this.tokens.replaceToken("".concat(resolvedFragmentPragmaBaseName).concat(jsxPragmaInfo.fragmentSuffix, ", null")); // Tag with children.

        this.processChildren();

        while (!this.tokens.matches1(tt.jsxTagEnd)) {
          this.tokens.replaceToken("");
        }

        this.tokens.replaceToken(")");
      } else {
        // Normal open tag or self-closing tag.
        this.processTagIntro();
        this.processProps(firstTokenStart);

        if (this.tokens.matches2(tt.slash, tt.jsxTagEnd)) {
          // Self-closing tag.
          this.tokens.replaceToken("");
          this.tokens.replaceToken(")");
        } else if (this.tokens.matches1(tt.jsxTagEnd)) {
          this.tokens.replaceToken(""); // Tag with children.

          this.processChildren();

          while (!this.tokens.matches1(tt.jsxTagEnd)) {
            this.tokens.replaceToken("");
          }

          this.tokens.replaceToken(")");
        } else {
          throw new Error("Expected either /> or > at the end of the tag.");
        }
      }
    }
  }]);

  return JSXTransformer;
}(Transformer);
/**
 * Spec for identifiers: https://tc39.github.io/ecma262/#prod-IdentifierStart.
 *
 * Really only treat anything starting with a-z as tag names.  `_`, `$`, `é`
 * should be treated as copmonent names
 */


export { JSXTransformer as default };
export function startsWithLowerCase(s) {
  var firstChar = s.charCodeAt(0);
  return firstChar >= charCodes.lowercaseA && firstChar <= charCodes.lowercaseZ;
}
/**
 * Turn the given jsxText string into a JS string literal. Leading and trailing
 * whitespace on lines is removed, except immediately after the open-tag and
 * before the close-tag. Empty lines are completely removed, and spaces are
 * added between lines after that.
 *
 * We use JSON.stringify to introduce escape characters as necessary, and trim
 * the start and end of each line and remove blank lines.
 */

function formatJSXTextLiteral(text) {
  var result = "";
  var whitespace = "";
  var isInInitialLineWhitespace = false;
  var seenNonWhitespace = false;

  for (var i = 0; i < text.length; i++) {
    var c = text[i];

    if (c === " " || c === "\t" || c === "\r") {
      if (!isInInitialLineWhitespace) {
        whitespace += c;
      }
    } else if (c === "\n") {
      whitespace = "";
      isInInitialLineWhitespace = true;
    } else {
      if (seenNonWhitespace && isInInitialLineWhitespace) {
        result += " ";
      }

      result += whitespace;
      whitespace = "";

      if (c === "&") {
        var _processEntity = processEntity(text, i + 1),
            entity = _processEntity.entity,
            newI = _processEntity.newI;

        i = newI - 1;
        result += entity;
      } else {
        result += c;
      }

      seenNonWhitespace = true;
      isInInitialLineWhitespace = false;
    }
  }

  if (!isInInitialLineWhitespace) {
    result += whitespace;
  }

  return JSON.stringify(result);
}
/**
 * Produce the code that should be printed after the JSX text string literal,
 * with most content removed, but all newlines preserved and all spacing at the
 * end preserved.
 */


function formatJSXTextReplacement(text) {
  var numNewlines = 0;
  var numSpaces = 0;

  var _iterator = _createForOfIteratorHelper(text),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var c = _step.value;

      if (c === "\n") {
        numNewlines++;
        numSpaces = 0;
      } else if (c === " ") {
        numSpaces++;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return "\n".repeat(numNewlines) + " ".repeat(numSpaces);
}
/**
 * Format a string in the value position of a JSX prop.
 *
 * Use the same implementation as convertAttribute from
 * babel-helper-builder-react-jsx.
 */


function formatJSXStringValueLiteral(text) {
  var result = "";

  for (var i = 0; i < text.length; i++) {
    var c = text[i];

    if (c === "\n") {
      if (/\s/.test(text[i + 1])) {
        result += " ";

        while (i < text.length && /\s/.test(text[i + 1])) {
          i++;
        }
      } else {
        result += "\n";
      }
    } else if (c === "&") {
      var _processEntity2 = processEntity(text, i + 1),
          entity = _processEntity2.entity,
          newI = _processEntity2.newI;

      result += entity;
      i = newI - 1;
    } else {
      result += c;
    }
  }

  return JSON.stringify(result);
}
/**
 * Starting at a &, see if there's an HTML entity (specified by name, decimal
 * char code, or hex char code) and return it if so.
 *
 * Modified from jsxReadString in babel-parser.
 */


function processEntity(text, indexAfterAmpersand) {
  var str = "";
  var count = 0;
  var entity;
  var i = indexAfterAmpersand;

  if (text[i] === "#") {
    var radix = 10;
    i++;
    var numStart;

    if (text[i] === "x") {
      radix = 16;
      i++;
      numStart = i;

      while (i < text.length && isHexDigit(text.charCodeAt(i))) {
        i++;
      }
    } else {
      numStart = i;

      while (i < text.length && isDecimalDigit(text.charCodeAt(i))) {
        i++;
      }
    }

    if (text[i] === ";") {
      var numStr = text.slice(numStart, i);

      if (numStr) {
        i++;
        entity = String.fromCodePoint(parseInt(numStr, radix));
      }
    }
  } else {
    while (i < text.length && count++ < 10) {
      var ch = text[i];
      i++;

      if (ch === ";") {
        entity = XHTMLEntities.get(str);
        break;
      }

      str += ch;
    }
  }

  if (!entity) {
    return {
      entity: "&",
      newI: indexAfterAmpersand
    };
  }

  return {
    entity: entity,
    newI: i
  };
}

function isDecimalDigit(code) {
  return code >= charCodes.digit0 && code <= charCodes.digit9;
}

function isHexDigit(code) {
  return code >= charCodes.digit0 && code <= charCodes.digit9 || code >= charCodes.lowercaseA && code <= charCodes.lowercaseF || code >= charCodes.uppercaseA && code <= charCodes.uppercaseF;
}